import { render, staticRenderFns } from "./tpl-1.vue?vue&type=template&id=3819ef08&scoped=true&"
import script from "./tpl-1.vue?vue&type=script&lang=js&"
export * from "./tpl-1.vue?vue&type=script&lang=js&"
import style0 from "./tpl-1.vue?vue&type=style&index=0&id=3819ef08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819ef08",
  null
  
)

export default component.exports